"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stateTaxDetail = void 0;
exports.stateTaxDetail = {
    AL: {
        type: "brackets",
        canDeductFederalTaxes: true,
        SINGLE: {
            brackets: [
                [0, 500, 0.02],
                [500, 3000, 0.04],
                [3000, 999999999, 0.05],
            ],
            standardDeduction: 3000,
            personalExemption: 1500,
        },
        MARRIED_SEPARATELY: {
            brackets: [
                [0, 500, 0.02],
                [500, 3000, 0.04],
                [3000, 999999999, 0.05],
            ],
            standardDeduction: 3000,
            personalExemption: 1500,
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [
                [0, 500, 0.02],
                [500, 3000, 0.04],
                [3000, 999999999, 0.05],
            ],
            standardDeduction: 3000,
            personalExemption: 1500,
        },
        MARRIED_JOINTLY: {
            brackets: [
                [0, 1000, 0.02],
                [1000, 6000, 0.04],
                [6000, 999999999, 0.05],
            ],
            standardDeduction: 8500,
            personalExemption: 3000,
        },
    },
    AK: { type: "none" },
    AZ: {
        type: "flat",
        SINGLE: {
            brackets: [[0, 999999999, 0.025]],
        },
        MARRIED_JOINTLY: {
            brackets: [[0, 999999999, 0.025]],
        },
        MARRIED_SEPARATELY: {
            brackets: [[0, 999999999, 0.025]],
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [[0, 999999999, 0.025]],
        },
    },
    AR: {
        type: "brackets",
        SINGLE: {
            brackets: [
                [0, 4300, 0.02],
                [4300, 8500, 0.04],
                [8500, 999999999, 0.055],
            ],
            personalExemption: 0,
            standardDeduction: 2270,
        },
        MARRIED_JOINTLY: {
            brackets: [
                [0, 4300, 0.02],
                [4300, 8500, 0.04],
                [8500, 999999999, 0.055],
            ],
            personalExemption: 0,
            standardDeduction: 4540,
        },
        MARRIED_SEPARATELY: {
            brackets: [
                [0, 4300, 0.02],
                [4300, 8500, 0.04],
                [8500, 999999999, 0.055],
            ],
            personalExemption: 0,
            standardDeduction: 2270,
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [
                [0, 4300, 0.02],
                [4300, 8500, 0.04],
                [8500, 999999999, 0.055],
            ],
            personalExemption: 0,
            standardDeduction: 2270,
        },
    },
    CA: {
        type: "brackets",
        otherTaxFunction: function (salary) {
            return salary * 0.009;
        },
        SINGLE: {
            brackets: [
                [0, 10100, 0.01],
                [10100, 23942, 0.02],
                [23942, 37788, 0.04],
                [37788, 52455, 0.06],
                [52455, 66295, 0.08],
                [66295, 338639, 0.093],
                [338639, 406364, 0.103],
                [406364, 677275, 0.113],
                [677275, 999999999, 0.123],
            ],
            personalExemption: 140,
            standardDeduction: 5202,
        },
        MARRIED_JOINTLY: {
            brackets: [
                [0, 20198, 0.01],
                [20198, 47884, 0.02],
                [47884, 75576, 0.04],
                [75576, 104910, 0.06],
                [104910, 132590, 0.08],
                [132590, 677278, 0.093],
                [677278, 812728, 0.103],
                [812728, 1354550, 0.113],
                [1354550, 999999999, 0.123],
            ],
            personalExemption: 140,
            standardDeduction: 10404,
        },
        MARRIED_SEPARATELY: {
            brackets: [
                [0, 10100, 0.01],
                [10100, 23942, 0.02],
                [23942, 37788, 0.04],
                [37788, 52455, 0.06],
                [52455, 66295, 0.08],
                [66295, 338639, 0.093],
                [338639, 406364, 0.103],
                [406364, 677275, 0.113],
                [677275, 999999999, 0.123],
            ],
            personalExemption: 140,
            standardDeduction: 5202,
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [
                [0, 20212, 0.01],
                [20212, 47887, 0.02],
                [47887, 61730, 0.04],
                [61730, 76397, 0.06],
                [76397, 90240, 0.08],
                [90240, 460547, 0.093],
                [460547, 552658, 0.103],
                [552658, 921095, 0.113],
                [921095, 999999999, 0.123],
            ],
            personalExemption: 140,
            standardDeduction: 10404,
        },
    },
    CO: {
        type: "flat",
        SINGLE: {
            brackets: [[0, 999999999, 0.044]],
            personalExemption: 0,
            standardDeduction: 0,
        },
        MARRIED_JOINTLY: {
            brackets: [[0, 999999999, 0.044]],
            personalExemption: 0,
            standardDeduction: 0,
        },
        MARRIED_SEPARATELY: {
            brackets: [[0, 999999999, 0.044]],
            personalExemption: 0,
            standardDeduction: 0,
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [[0, 999999999, 0.044]],
            personalExemption: 0,
            standardDeduction: 0,
        },
    },
    CT: {
        type: "brackets",
        SINGLE: {
            brackets: [
                [0, 10000, 0.03],
                [10000, 50000, 0.05],
                [50000, 100000, 0.055],
                [100000, 200000, 0.06],
                [200000, 250000, 0.065],
                [250000, 500000, 0.069],
                [500000, 999999999, 0.0699],
            ],
        },
        MARRIED_SEPARATELY: {
            brackets: [
                [0, 10000, 0.03],
                [10000, 50000, 0.05],
                [50000, 100000, 0.055],
                [100000, 200000, 0.06],
                [200000, 250000, 0.065],
                [250000, 500000, 0.069],
                [500000, 999999999, 0.0699],
            ],
        },
        MARRIED_JOINTLY: {
            brackets: [
                [0, 20000, 0.03],
                [20000, 100000, 0.05],
                [100000, 200000, 0.055],
                [200000, 400000, 0.06],
                [400000, 500000, 0.065],
                [500000, 1000000, 0.069],
                [1000000, 999999999, 0.0699],
            ],
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [
                [0, 16000, 0.03],
                [16000, 80000, 0.05],
                [80000, 160000, 0.055],
                [160000, 320000, 0.06],
                [320000, 400000, 0.065],
                [400000, 800000, 0.069],
                [800000, 999999999, 0.0699],
            ],
        },
    },
    DE: {
        type: "brackets",
        SINGLE: {
            brackets: [
                [2000, 5000, 0.022],
                [5000, 10000, 0.039],
                [10000, 20000, 0.048],
                [20000, 25000, 0.052],
                [25000, 60000, 0.055],
                [60000, 999999999, 0.066],
            ],
            personalExemption: 0,
            standardDeduction: 5700,
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [
                [2000, 5000, 0.022],
                [5000, 10000, 0.039],
                [10000, 20000, 0.048],
                [20000, 25000, 0.052],
                [25000, 60000, 0.055],
                [60000, 999999999, 0.066],
            ],
            personalExemption: 0,
            standardDeduction: 5700,
        },
        MARRIED_JOINTLY: {
            brackets: [
                [2000, 5000, 0.022],
                [5000, 10000, 0.039],
                [10000, 20000, 0.048],
                [20000, 25000, 0.052],
                [25000, 60000, 0.055],
                [60000, 999999999, 0.066],
            ],
            standardDeduction: 11400,
        },
        MARRIED_SEPARATELY: {
            brackets: [
                [2000, 5000, 0.022],
                [5000, 10000, 0.039],
                [10000, 20000, 0.048],
                [20000, 25000, 0.052],
                [25000, 60000, 0.055],
                [60000, 999999999, 0.066],
            ],
            standardDeduction: 5700,
        },
    },
    FL: { type: "none" },
    GA: {
        type: "brackets",
        SINGLE: {
            brackets: [
                [0, 750, 0.01],
                [750, 2250, 0.02],
                [2250, 3750, 0.03],
                [3750, 5250, 0.04],
                [5250, 7000, 0.05],
                [7000, 999999999, 0.0575],
            ],
            standardDeduction: 5400,
        },
        MARRIED_SEPARATELY: {
            brackets: [
                [0, 500, 0.01],
                [500, 1500, 0.02],
                [1500, 2500, 0.03],
                [2500, 3500, 0.04],
                [3500, 5000, 0.05],
                [5000, 999999999, 0.0575],
            ],
            standardDeduction: 5400,
        },
        MARRIED_JOINTLY: {
            brackets: [
                [0, 1000, 0.01],
                [1000, 3000, 0.02],
                [3000, 5000, 0.03],
                [5000, 7000, 0.04],
                [7000, 10000, 0.05],
                [10000, 999999999, 0.0575],
            ],
            standardDeduction: 7100,
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [
                [0, 1000, 0.01],
                [1000, 3000, 0.02],
                [3000, 5000, 0.03],
                [5000, 7000, 0.04],
                [7000, 10000, 0.05],
                [10000, 999999999, 0.0575],
            ],
            standardDeduction: 7100,
        },
    },
    HI: {
        type: "brackets",
        SINGLE: {
            brackets: [
                [0, 2400, 0.014],
                [2400, 4800, 0.032],
                [4800, 9600, 0.055],
                [9600, 14400, 0.064],
                [14400, 19200, 0.068],
                [19200, 24000, 0.072],
                [24000, 36000, 0.076],
                [36000, 48000, 0.079],
                [48000, 150000, 0.0825],
                [150000, 175000, 0.09],
                [175000, 200000, 0.1],
                [200000, 999999999, 0.11],
            ],
            standardDeduction: 2200,
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [
                [0, 3600, 0.014],
                [3600, 7200, 0.032],
                [7200, 14400, 0.055],
                [14400, 21600, 0.064],
                [21600, 28800, 0.068],
                [28800, 36000, 0.072],
                [36000, 54000, 0.076],
                [54000, 72000, 0.079],
                [72000, 225000, 0.0825],
                [225000, 262500, 0.09],
                [262500, 300000, 0.1],
                [300000, 999999999, 0.11],
            ],
            standardDeduction: 3212,
        },
        MARRIED_JOINTLY: {
            brackets: [
                [0, 4800, 0.014],
                [4800, 9600, 0.032],
                [9600, 19200, 0.055],
                [19200, 28800, 0.064],
                [28800, 38400, 0.068],
                [38400, 48000, 0.072],
                [48000, 72000, 0.076],
                [72000, 96000, 0.079],
                [96000, 300000, 0.0825],
                [300000, 350000, 0.09],
                [350000, 400000, 0.1],
                [400000, 999999999, 0.11],
            ],
            standardDeduction: 4400,
        },
        MARRIED_SEPARATELY: {
            brackets: [
                [0, 2400, 0.014],
                [2400, 4800, 0.032],
                [4800, 9600, 0.055],
                [9600, 14400, 0.064],
                [14400, 19200, 0.068],
                [19200, 24000, 0.072],
                [24000, 36000, 0.076],
                [36000, 48000, 0.079],
                [48000, 150000, 0.0825],
                [150000, 175000, 0.09],
                [175000, 200000, 0.1],
                [200000, 999999999, 0.11],
            ],
            standardDeduction: 2200,
        },
    },
    ID: {
        type: "flat",
        SINGLE: { brackets: [[0, 999999999, 0.058]], standardDeduction: 13850 },
        MARRIED_JOINTLY: {
            brackets: [[0, 999999999, 0.058]],
            standardDeduction: 27700,
        },
        MARRIED_SEPARATELY: {
            brackets: [[0, 999999999, 0.058]],
            standardDeduction: 13850,
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [[0, 999999999, 0.058]],
            standardDeduction: 20800,
        },
    },
    IL: {
        type: "flat",
        SINGLE: { brackets: [[0, 999999999, 0.0495]] },
        MARRIED_JOINTLY: {
            brackets: [[0, 999999999, 0.0495]],
        },
        MARRIED_SEPARATELY: {
            brackets: [[0, 999999999, 0.0495]],
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [[0, 999999999, 0.0495]],
        },
    },
    IN: {
        type: "flat",
        SINGLE: { brackets: [[0, 999999999, 0.0315]], personalExemption: 1000 },
        MARRIED_JOINTLY: {
            brackets: [[0, 999999999, 0.0315]],
            personalExemption: 2000,
        },
        MARRIED_SEPARATELY: {
            brackets: [[0, 999999999, 0.0315]],
            personalExemption: 1000,
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [[0, 999999999, 0.0315]],
            personalExemption: 1000,
        },
    },
    IA: {
        type: "brackets",
        SINGLE: {
            brackets: [
                [0, 6000, 0.044],
                [6000, 30000, 0.0482],
                [30000, 75000, 0.057],
                [75000, 999999999, 0.06],
            ],
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [
                [0, 6000, 0.044],
                [6000, 30000, 0.0482],
                [30000, 75000, 0.057],
                [75000, 999999999, 0.06],
            ],
        },
        MARRIED_JOINTLY: {
            brackets: [
                [0, 12000, 0.044],
                [12000, 60000, 0.0482],
                [60000, 150000, 0.057],
                [150000, 999999999, 0.06],
            ],
        },
        MARRIED_SEPARATELY: {
            brackets: [
                [0, 6000, 0.044],
                [6000, 30000, 0.0482],
                [30000, 75000, 0.057],
                [75000, 999999999, 0.06],
            ],
        },
    },
    KS: {
        type: "brackets",
        SINGLE: {
            brackets: [
                [0, 15000, 0.031],
                [15000, 30000, 0.0525],
                [30000, 999999999, 0.057],
            ],
            standardDeduction: 3500,
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [
                [0, 15000, 0.031],
                [15000, 30000, 0.0525],
                [30000, 999999999, 0.057],
            ],
            standardDeduction: 6000,
        },
        MARRIED_JOINTLY: {
            brackets: [
                [0, 30000, 0.031],
                [30000, 60000, 0.0525],
                [60000, 999999999, 0.057],
            ],
            standardDeduction: 8000,
        },
        MARRIED_SEPARATELY: {
            brackets: [
                [0, 15000, 0.031],
                [15000, 30000, 0.0525],
                [30000, 999999999, 0.057],
            ],
            standardDeduction: 4000,
        },
    },
    KY: {
        type: "flat",
        SINGLE: { brackets: [[0, 999999999, 0.045]], standardDeduction: 2980 },
        HEAD_OF_HOUSEHOLD: {
            brackets: [[0, 999999999, 0.045]],
            standardDeduction: 2980,
        },
        MARRIED_JOINTLY: {
            brackets: [[0, 999999999, 0.045]],
            standardDeduction: 2980,
        },
        MARRIED_SEPARATELY: {
            brackets: [[0, 999999999, 0.045]],
            standardDeduction: 2980,
        },
    },
    NV: { type: "none" },
    SD: { type: "none" },
    TX: { type: "none" },
    WA: { type: "none" },
    WY: { type: "none" },
    LA: {
        type: "brackets",
        SINGLE: {
            brackets: [
                [0, 12500, 0.0185],
                [12500, 50000, 0.035],
                [50000, 999999999, 0.0425],
            ],
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [
                [0, 12500, 0.0185],
                [12500, 50000, 0.035],
                [50000, 999999999, 0.0425],
            ],
        },
        MARRIED_JOINTLY: {
            brackets: [
                [0, 25000, 0.0185],
                [25000, 100000, 0.035],
                [100000, 999999999, 0.0425],
            ],
        },
        MARRIED_SEPARATELY: {
            brackets: [
                [0, 12500, 0.0185],
                [12500, 50000, 0.035],
                [50000, 999999999, 0.0425],
            ],
        },
    },
    ME: {
        type: "brackets",
        SINGLE: {
            brackets: [
                [0, 24500, 0.058],
                [24500, 58050, 0.0675],
                [58050, 999999999, 0.0715],
            ],
            standardDeduction: 13850,
            personalExemption: 4700,
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [
                [0, 24500, 0.058],
                [24500, 58050, 0.0675],
                [58050, 999999999, 0.0715],
            ],
            standardDeduction: 13850,
            personalExemption: 4700,
        },
        MARRIED_JOINTLY: {
            brackets: [
                [0, 49050, 0.058],
                [49050, 116100, 0.0675],
                [116100, 999999999, 0.0715],
            ],
            standardDeduction: 27700,
            personalExemption: 9400,
        },
        MARRIED_SEPARATELY: {
            brackets: [
                [0, 24500, 0.058],
                [24500, 58050, 0.0675],
                [58050, 999999999, 0.0715],
            ],
            standardDeduction: 13850,
            personalExemption: 4700,
        },
    },
    MD: {
        type: "brackets",
        otherTaxFunction: function (salary) {
            return salary * 0.03;
        },
        SINGLE: {
            brackets: [
                [0, 1000, 0.02],
                [1000, 2000, 0.03],
                [2000, 3000, 0.04],
                [3000, 100000, 0.0475],
                [100000, 125000, 0.05],
                [125000, 150000, 0.0525],
                [150000, 250000, 0.055],
                [250000, 999999999, 0.0575],
            ],
            standardDeduction: 2400,
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [
                [0, 1000, 0.02],
                [1000, 2000, 0.03],
                [2000, 3000, 0.04],
                [3000, 150000, 0.0475],
                [150000, 175000, 0.05],
                [175000, 225000, 0.0525],
                [225000, 300000, 0.055],
                [300000, 999999999, 0.0575],
            ],
            standardDeduction: 4850,
        },
        MARRIED_JOINTLY: {
            brackets: [
                [0, 1000, 0.02],
                [1000, 2000, 0.03],
                [2000, 3000, 0.04],
                [3000, 150000, 0.0475],
                [150000, 175000, 0.05],
                [175000, 225000, 0.0525],
                [225000, 300000, 0.055],
                [300000, 999999999, 0.0575],
            ],
            standardDeduction: 4850,
        },
        MARRIED_SEPARATELY: {
            brackets: [
                [0, 1000, 0.02],
                [1000, 2000, 0.03],
                [2000, 3000, 0.04],
                [3000, 100000, 0.0475],
                [100000, 125000, 0.05],
                [125000, 150000, 0.0525],
                [150000, 250000, 0.055],
                [250000, 999999999, 0.0575],
            ],
            standardDeduction: 2400,
        },
    },
    MA: {
        type: "brackets",
        SINGLE: {
            brackets: [
                [0, 1000000, 0.05],
                [1000000, 999999999, 0.09],
            ],
            personalExemption: 4400,
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [
                [0, 1000000, 0.05],
                [1000000, 999999999, 0.09],
            ],
            personalExemption: 6800,
        },
        MARRIED_JOINTLY: {
            brackets: [
                [0, 1000000, 0.05],
                [1000000, 999999999, 0.09],
            ],
            personalExemption: 8800,
        },
        MARRIED_SEPARATELY: {
            brackets: [
                [0, 1000000, 0.05],
                [1000000, 999999999, 0.09],
            ],
            personalExemption: 4400,
        },
    },
    MI: {
        type: "flat",
        SINGLE: { brackets: [[0, 999999999, 0.0425]], personalExemption: 5000 },
        HEAD_OF_HOUSEHOLD: {
            brackets: [[0, 999999999, 0.0425]],
            personalExemption: 10000,
        },
        MARRIED_JOINTLY: {
            brackets: [[0, 999999999, 0.0425]],
            personalExemption: 10000,
        },
        MARRIED_SEPARATELY: {
            brackets: [[0, 999999999, 0.0425]],
            personalExemption: 5000,
        },
    },
    MN: {
        type: "brackets",
        SINGLE: {
            brackets: [
                [0, 30070, 0.0535],
                [30070, 98760, 0.068],
                [98760, 183340, 0.0785],
                [183340, 999999999, 0.0985],
            ],
            standardDeduction: 13825,
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [
                [0, 37010, 0.0535],
                [37010, 148730, 0.068],
                [148730, 243720, 0.0785],
                [243720, 999999999, 0.0985],
            ],
            standardDeduction: 20800,
        },
        MARRIED_JOINTLY: {
            brackets: [
                [0, 43950, 0.0535],
                [43950, 174610, 0.068],
                [174610, 304970, 0.0785],
                [304970, 999999999, 0.0985],
            ],
            standardDeduction: 27650,
        },
        MARRIED_SEPARATELY: {
            brackets: [
                [0, 21975, 0.0535],
                [21975, 87305, 0.068],
                [87305, 152485, 0.0785],
                [152485, 999999999, 0.0985],
            ],
            standardDeduction: 13825,
        },
    },
    MS: {
        type: "flat",
        SINGLE: { brackets: [[10000, 999999999, 0.05]], standardDeduction: 2300 },
        HEAD_OF_HOUSEHOLD: {
            brackets: [[10000, 999999999, 0.05]],
            standardDeduction: 3400,
        },
        MARRIED_JOINTLY: {
            brackets: [[10000, 999999999, 0.05]],
            standardDeduction: 4600,
        },
        MARRIED_SEPARATELY: {
            brackets: [[10000, 999999999, 0.05]],
            standardDeduction: 2300,
        },
    },
    MO: {
        type: "brackets",
        SINGLE: {
            brackets: [
                [1121, 2242, 0.02],
                [2242, 3363, 0.025],
                [3363, 4484, 0.03],
                [4484, 5605, 0.035],
                [5605, 6726, 0.04],
                [6726, 7847, 0.045],
                [7847, 999999999, 0.0495],
            ],
            standardDeduction: 13850,
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [
                [1121, 2242, 0.02],
                [2242, 3363, 0.025],
                [3363, 4484, 0.03],
                [4484, 5605, 0.035],
                [5605, 6726, 0.04],
                [6726, 7847, 0.045],
                [7847, 999999999, 0.0495],
            ],
            standardDeduction: 20800,
        },
        MARRIED_JOINTLY: {
            brackets: [
                [1121, 2242, 0.02],
                [2242, 3363, 0.025],
                [3363, 4484, 0.03],
                [4484, 5605, 0.035],
                [5605, 6726, 0.04],
                [6726, 7847, 0.045],
                [7847, 999999999, 0.0495],
            ],
            standardDeduction: 27700,
        },
        MARRIED_SEPARATELY: {
            brackets: [
                [1121, 2242, 0.02],
                [2242, 3363, 0.025],
                [3363, 4484, 0.03],
                [4484, 5605, 0.035],
                [5605, 6726, 0.04],
                [6726, 7847, 0.045],
                [7847, 999999999, 0.0495],
            ],
            standardDeduction: 13850,
        },
    },
    MT: {
        type: "brackets",
        SINGLE: {
            brackets: [
                [0, 3600, 0.01],
                [3600, 6300, 0.02],
                [6300, 9700, 0.03],
                [9700, 13000, 0.04],
                [13000, 16800, 0.05],
                [16800, 21600, 0.06],
                [21600, 999999999, 0.0675],
            ],
            standardDeduction: 5540,
            personalExemption: 2960,
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [
                [0, 3600, 0.01],
                [3600, 6300, 0.02],
                [6300, 9700, 0.03],
                [9700, 13000, 0.04],
                [13000, 16800, 0.05],
                [16800, 21600, 0.06],
                [21600, 999999999, 0.0675],
            ],
            standardDeduction: 11080,
            personalExemption: 2960,
        },
        MARRIED_JOINTLY: {
            brackets: [
                [0, 3600, 0.01],
                [3600, 6300, 0.02],
                [6300, 9700, 0.03],
                [9700, 13000, 0.04],
                [13000, 16800, 0.05],
                [16800, 21600, 0.06],
                [21600, 999999999, 0.0675],
            ],
            standardDeduction: 11080,
            personalExemption: 5920,
        },
        MARRIED_SEPARATELY: {
            brackets: [
                [0, 3600, 0.01],
                [3600, 6300, 0.02],
                [6300, 9700, 0.03],
                [9700, 13000, 0.04],
                [13000, 16800, 0.05],
                [16800, 21600, 0.06],
                [21600, 999999999, 0.0675],
            ],
            standardDeduction: 5540,
            personalExemption: 2960,
        },
    },
    NE: {
        type: "brackets",
        SINGLE: {
            brackets: [
                [0, 3700, 0.0246],
                [3700, 22170, 0.0351],
                [22170, 35730, 0.0501],
                [35730, 999999999, 0.0664],
            ],
            standardDeduction: 7900,
            personalExemption: 157,
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [
                [0, 6900, 0.0246],
                [6900, 35480, 0.0351],
                [35480, 52980, 0.0501],
                [52980, 999999999, 0.0664],
            ],
            standardDeduction: 11600,
            personalExemption: 314,
        },
        MARRIED_JOINTLY: {
            brackets: [
                [0, 7390, 0.0246],
                [7390, 44350, 0.0351],
                [44350, 71460, 0.0501],
                [71460, 999999999, 0.0664],
            ],
            standardDeduction: 15800,
            personalExemption: 314,
        },
        MARRIED_SEPARATELY: {
            brackets: [
                [0, 3700, 0.0246],
                [3700, 22170, 0.0351],
                [22170, 35730, 0.0501],
                [35730, 999999999, 0.0664],
            ],
            standardDeduction: 7900,
            personalExemption: 157,
        },
    },
    NH: { type: "none" },
    NJ: {
        type: "brackets",
        SINGLE: {
            brackets: [
                [0, 20000, 0.014],
                [20000, 35000, 0.0175],
                [35000, 40000, 0.035],
                [40000, 75000, 0.0553],
                [75000, 500000, 0.0637],
                [500000, 1000000, 0.0897],
                [1000000, 999999999, 0.1075],
            ],
            personalExemption: 1000,
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [
                [0, 20000, 0.014],
                [20000, 50000, 0.0175],
                [50000, 70000, 0.0245],
                [70000, 80000, 0.035],
                [80000, 150000, 0.0553],
                [150000, 500000, 0.0637],
                [500000, 1000000, 0.0897],
                [1000000, 999999999, 0.1075],
            ],
            personalExemption: 2000,
        },
        MARRIED_JOINTLY: {
            brackets: [
                [0, 20000, 0.014],
                [20000, 50000, 0.0175],
                [50000, 70000, 0.0245],
                [70000, 80000, 0.035],
                [80000, 150000, 0.0553],
                [150000, 500000, 0.0637],
                [500000, 1000000, 0.0897],
                [1000000, 999999999, 0.1075],
            ],
            personalExemption: 2000,
        },
        MARRIED_SEPARATELY: {
            brackets: [
                [0, 20000, 0.014],
                [20000, 35000, 0.0175],
                [35000, 40000, 0.035],
                [40000, 75000, 0.0553],
                [75000, 500000, 0.0637],
                [500000, 1000000, 0.0897],
                [1000000, 999999999, 0.1075],
            ],
            personalExemption: 1000,
        },
    },
    NM: {
        type: "brackets",
        SINGLE: {
            brackets: [
                [0, 5500, 0.017],
                [5500, 11000, 0.032],
                [11000, 16000, 0.047],
                [16000, 210000, 0.049],
                [210000, 999999999, 0.059],
            ],
            standardDeduction: 13850,
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [
                [0, 8000, 0.017],
                [8000, 16000, 0.032],
                [16000, 24000, 0.047],
                [24000, 315000, 0.049],
                [315000, 999999999, 0.059],
            ],
            standardDeduction: 20800,
        },
        MARRIED_JOINTLY: {
            brackets: [
                [0, 8000, 0.017],
                [8000, 16000, 0.032],
                [16000, 24000, 0.047],
                [24000, 315000, 0.049],
                [315000, 999999999, 0.059],
            ],
            standardDeduction: 27700,
        },
        MARRIED_SEPARATELY: {
            brackets: [
                [0, 5500, 0.017],
                [5500, 11000, 0.032],
                [11000, 16000, 0.047],
                [16000, 210000, 0.049],
                [210000, 999999999, 0.059],
            ],
            standardDeduction: 13850,
        },
    },
    NY: {
        type: "brackets",
        SINGLE: {
            brackets: [
                [0, 8500, 0.04],
                [8500, 11700, 0.045],
                [11700, 13900, 0.0525],
                [13900, 80650, 0.0585],
                [80650, 215400, 0.0625],
                [215400, 1077550, 0.0685],
                [1077550, 5000000, 0.0965],
                [5000000, 25000000, 0.103],
                [25000000, 999999999, 0.109],
            ],
            // standardDeduction: 8000,
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [
                [0, 12800, 0.04],
                [12800, 17650, 0.045],
                [17650, 20900, 0.0525],
                [20900, 107650, 0.0585],
                [107650, 269300, 0.0625],
                [269300, 1616450, 0.0685],
                [1616450, 5000000, 0.0965],
                [5000000, 25000000, 0.103],
                [25000000, 999999999, 0.109],
            ],
            standardDeduction: 11200,
        },
        MARRIED_JOINTLY: {
            brackets: [
                [0, 17150, 0.04],
                [17150, 23600, 0.045],
                [23600, 27900, 0.0525],
                [27900, 161550, 0.0585],
                [161550, 323200, 0.0625],
                [323200, 2155350, 0.0685],
                [2155350, 5000000, 0.0965],
                [5000000, 25000000, 0.103],
                [25000000, 999999999, 0.109],
            ],
            // standardDeduction: 16050,
        },
        MARRIED_SEPARATELY: {
            brackets: [
                [0, 8500, 0.04],
                [8500, 11700, 0.045],
                [11700, 13900, 0.0525],
                [13900, 80650, 0.0585],
                [80650, 215400, 0.0625],
                [215400, 1077550, 0.0685],
                [1077550, 5000000, 0.0965],
                [5000000, 25000000, 0.103],
                [25000000, 999999999, 0.109],
            ],
            standardDeduction: 8000,
        },
    },
    NC: {
        type: "flat",
        SINGLE: { brackets: [[0, 999999999, 0.0475]], standardDeduction: 12750 },
        HEAD_OF_HOUSEHOLD: {
            brackets: [[0, 999999999, 0.0475]],
            standardDeduction: 19125,
        },
        MARRIED_JOINTLY: {
            brackets: [[0, 999999999, 0.0475]],
            standardDeduction: 25500,
        },
        MARRIED_SEPARATELY: {
            brackets: [[0, 999999999, 0.0475]],
            standardDeduction: 12750,
        },
    },
    ND: {
        type: "brackets",
        SINGLE: {
            brackets: [
                [0, 41775, 0.011],
                [41775, 101050, 0.0204],
                [101050, 210825, 0.0227],
                [210825, 458350, 0.0264],
                [458350, 999999999, 0.029],
            ],
            standardDeduction: 13850,
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [
                [0, 55900, 0.011],
                [55900, 144400, 0.0204],
                [144400, 233750, 0.0227],
                [233750, 458350, 0.0264],
                [458350, 999999999, 0.029],
            ],
            standardDeduction: 20800,
        },
        MARRIED_JOINTLY: {
            brackets: [
                [0, 69700, 0.011],
                [69700, 168450, 0.0204],
                [168450, 256650, 0.0227],
                [256650, 458350, 0.0264],
                [458350, 999999999, 0.029],
            ],
            standardDeduction: 27700,
        },
        MARRIED_SEPARATELY: {
            brackets: [
                [0, 34850, 0.011],
                [34850, 84225, 0.0204],
                [84225, 128325, 0.0227],
                [128325, 229175, 0.0264],
                [229175, 999999999, 0.029],
            ],
            standardDeduction: 13850,
        },
    },
    OH: {
        type: "brackets",
        SINGLE: {
            brackets: [
                [26050, 46100, 0.0277],
                [46100, 92150, 0.0323],
                [92150, 115300, 0.0369],
                [115300, 999999999, 0.0399],
            ],
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [
                [26050, 46100, 0.0277],
                [46100, 92150, 0.0323],
                [92150, 115300, 0.0369],
                [115300, 999999999, 0.0399],
            ],
        },
        MARRIED_JOINTLY: {
            brackets: [
                [26050, 46100, 0.0277],
                [46100, 92150, 0.0323],
                [92150, 115300, 0.0369],
                [115300, 999999999, 0.0399],
            ],
        },
        MARRIED_SEPARATELY: {
            brackets: [
                [26050, 46100, 0.0277],
                [46100, 92150, 0.0323],
                [92150, 115300, 0.0369],
                [115300, 999999999, 0.0399],
            ],
        },
    },
    OK: {
        type: "brackets",
        SINGLE: {
            brackets: [
                [0, 1000, 0.0025],
                [1000, 2500, 0.0075],
                [2500, 3750, 0.0175],
                [3750, 4900, 0.0275],
                [4900, 7200, 0.0375],
                [7200, 999999999, 0.0475],
            ],
            standardDeduction: 6350,
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [
                [0, 2000, 0.0025],
                [2000, 5000, 0.0075],
                [5000, 7500, 0.0175],
                [7500, 9800, 0.0275],
                [9800, 12200, 0.0375],
                [12200, 999999999, 0.0475],
            ],
            standardDeduction: 9350,
        },
        MARRIED_JOINTLY: {
            brackets: [
                [0, 2000, 0.0025],
                [2000, 5000, 0.0075],
                [5000, 7500, 0.0175],
                [7500, 9800, 0.0275],
                [9800, 12200, 0.0375],
                [12200, 999999999, 0.0475],
            ],
            standardDeduction: 12700,
        },
        MARRIED_SEPARATELY: {
            brackets: [
                [0, 1000, 0.0025],
                [1000, 2500, 0.0075],
                [2500, 3750, 0.0175],
                [3750, 4900, 0.0275],
                [4900, 7200, 0.0375],
                [7200, 999999999, 0.0475],
            ],
            standardDeduction: 6350,
        },
    },
    OR: {
        type: "brackets",
        SINGLE: {
            brackets: [
                [0, 4050, 0.0475],
                [4050, 10200, 0.0675],
                [10200, 125000, 0.0875],
                [125000, 999999999, 0.099],
            ],
            standardDeduction: 2605,
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [
                [0, 8100, 0.0475],
                [8100, 20400, 0.0675],
                [20400, 250000, 0.0875],
                [250000, 999999999, 0.099],
            ],
            standardDeduction: 4195,
        },
        MARRIED_JOINTLY: {
            brackets: [
                [0, 8100, 0.0475],
                [8100, 20400, 0.0675],
                [20400, 250000, 0.0875],
                [250000, 999999999, 0.099],
            ],
            standardDeduction: 5210,
        },
        MARRIED_SEPARATELY: {
            brackets: [
                [0, 4050, 0.0475],
                [4050, 10200, 0.0675],
                [10200, 125000, 0.0875],
                [125000, 999999999, 0.099],
            ],
            standardDeduction: 2605,
        },
    },
    PA: {
        type: "flat",
        SINGLE: { brackets: [[0, 999999999, 0.0307]] },
        HEAD_OF_HOUSEHOLD: { brackets: [[0, 999999999, 0.0307]] },
        MARRIED_JOINTLY: { brackets: [[0, 999999999, 0.0307]] },
        MARRIED_SEPARATELY: { brackets: [[0, 999999999, 0.0307]] },
    },
    RI: {
        type: "brackets",
        otherTaxFunction: function (salary) {
            return (salary - (salary - 84000)) * 0.011;
        },
        SINGLE: {
            brackets: [
                [0, 68200, 0.0375],
                [68200, 155050, 0.0475],
                [155050, 999999999, 0.0599],
            ],
            standardDeduction: 10000,
            personalExemption: 4700,
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [
                [0, 68200, 0.0375],
                [68200, 155050, 0.0475],
                [155050, 999999999, 0.0599],
            ],
            standardDeduction: 15050,
            personalExemption: 4700,
        },
        MARRIED_JOINTLY: {
            brackets: [
                [0, 68200, 0.0375],
                [68200, 155050, 0.0475],
                [155050, 999999999, 0.0599],
            ],
            standardDeduction: 20050,
            personalExemption: 9400,
        },
        MARRIED_SEPARATELY: {
            brackets: [
                [0, 68200, 0.0375],
                [68200, 155050, 0.0475],
                [155050, 999999999, 0.0599],
            ],
            standardDeduction: 10000,
            personalExemption: 4700,
        },
    },
    SC: {
        type: "brackets",
        SINGLE: {
            brackets: [
                [3200, 16040, 0.03],
                [16040, 999999999, 0.065],
            ],
            // standardDeduction: 13850,
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [
                [3200, 16040, 0.03],
                [16040, 999999999, 0.065],
            ],
            // standardDeduction: 20850,
        },
        MARRIED_JOINTLY: {
            brackets: [
                [3200, 16040, 0.03],
                [16040, 999999999, 0.065],
            ],
            // standardDeduction: 27700,
        },
        MARRIED_SEPARATELY: {
            brackets: [
                [3200, 16040, 0.03],
                [16040, 999999999, 0.065],
            ],
            // standardDeduction: 13850,
        },
    },
    UT: {
        type: "flat",
        SINGLE: { brackets: [[0, 999999999, 0.0485]] },
        HEAD_OF_HOUSEHOLD: { brackets: [[0, 999999999, 0.0485]] },
        MARRIED_JOINTLY: { brackets: [[0, 999999999, 0.0485]] },
        MARRIED_SEPARATELY: { brackets: [[0, 999999999, 0.0485]] },
    },
    VT: {
        type: "brackets",
        SINGLE: {
            brackets: [
                [0, 42150, 0.0335],
                [42150, 102200, 0.066],
                [102200, 213150, 0.076],
                [213150, 999999999, 0.0875],
            ],
            // standardDeduction: 6500,
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [
                [0, 56500, 0.0335],
                [56500, 145950, 0.066],
                [145950, 236350, 0.076],
                [236350, 999999999, 0.0875],
            ],
            // standardDeduction: 9800,
        },
        MARRIED_JOINTLY: {
            brackets: [
                [0, 70450, 0.0335],
                [70450, 170300, 0.066],
                [170300, 259500, 0.076],
                [259500, 999999999, 0.0875],
            ],
            // standardDeduction: 13050,
        },
        MARRIED_SEPARATELY: {
            brackets: [
                [0, 35225, 0.0335],
                [35225, 85150, 0.066],
                [85150, 129750, 0.076],
                [129750, 999999999, 0.0875],
            ],
            // standardDeduction: 6500,
        },
    },
    VA: {
        type: "brackets",
        SINGLE: {
            brackets: [
                [0, 3000, 0.02],
                [3000, 5000, 0.03],
                [5000, 17000, 0.05],
                [17000, 999999999, 0.0575],
            ],
            standardDeduction: 8000,
            personalExemption: 930,
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [
                [0, 3000, 0.02],
                [3000, 5000, 0.03],
                [5000, 17000, 0.05],
                [17000, 999999999, 0.0575],
            ],
            standardDeduction: 8000,
            personalExemption: 930,
        },
        MARRIED_JOINTLY: {
            brackets: [
                [0, 3000, 0.02],
                [3000, 5000, 0.03],
                [5000, 17000, 0.05],
                [17000, 999999999, 0.0575],
            ],
            standardDeduction: 16000,
            personalExemption: 1860,
        },
        MARRIED_SEPARATELY: {
            brackets: [
                [0, 3000, 0.02],
                [3000, 5000, 0.03],
                [5000, 17000, 0.05],
                [17000, 999999999, 0.0575],
            ],
            standardDeduction: 8000,
            personalExemption: 930,
        },
    },
    WV: {
        type: "brackets",
        SINGLE: {
            brackets: [
                [0, 10000, 0.03],
                [10000, 25000, 0.04],
                [25000, 40000, 0.045],
                [40000, 60000, 0.06],
                [60000, 999999999, 0.065],
            ],
            personalExemption: 2000,
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [
                [0, 10000, 0.03],
                [10000, 25000, 0.04],
                [25000, 40000, 0.045],
                [40000, 60000, 0.06],
                [60000, 999999999, 0.065],
            ],
            personalExemption: 2000,
        },
        MARRIED_JOINTLY: {
            brackets: [
                [0, 10000, 0.03],
                [10000, 25000, 0.04],
                [25000, 40000, 0.045],
                [40000, 60000, 0.06],
                [60000, 999999999, 0.065],
            ],
            personalExemption: 4000,
        },
        MARRIED_SEPARATELY: {
            brackets: [
                [0, 10000, 0.03],
                [10000, 25000, 0.04],
                [25000, 40000, 0.045],
                [40000, 60000, 0.06],
                [60000, 999999999, 0.065],
            ],
            personalExemption: 2000,
        },
    },
    WI: {
        type: "brackets",
        SINGLE: {
            brackets: [
                [0, 13810, 0.0354],
                [13810, 27630, 0.0465],
                [27630, 304170, 0.053],
                [304170, 999999999, 0.0765],
            ],
            // standardDeduction: 12760,
            personalExemption: 700,
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [
                [0, 13810, 0.0354],
                [13810, 27630, 0.0465],
                [27630, 304170, 0.053],
                [304170, 999999999, 0.0765],
            ],
            // standardDeduction: 12760,
            personalExemption: 700,
        },
        MARRIED_JOINTLY: {
            brackets: [
                [0, 18420, 0.0354],
                [18420, 36840, 0.0465],
                [36840, 405550, 0.053],
                [405550, 999999999, 0.0765],
            ],
            // standardDeduction: 23620,
            personalExemption: 1400,
        },
        MARRIED_SEPARATELY: {
            brackets: [
                [0, 9210, 0.0354],
                [9210, 18420, 0.0465],
                [18420, 202780, 0.053],
                [202780, 999999999, 0.0765],
            ],
            // standardDeduction: 12760,
            personalExemption: 700,
        },
    },
    DC: {
        type: "brackets",
        SINGLE: {
            brackets: [
                [0, 10000, 0.04],
                [10000, 40000, 0.06],
                [40000, 60000, 0.065],
                [60000, 250000, 0.085],
                [250000, 500000, 0.0925],
                [500000, 1000000, 0.0975],
                [1000000, 999999999, 0.1075],
            ],
            // standardDeduction: 13850,
        },
        HEAD_OF_HOUSEHOLD: {
            brackets: [
                [0, 10000, 0.04],
                [10000, 40000, 0.06],
                [40000, 60000, 0.065],
                [60000, 250000, 0.085],
                [250000, 500000, 0.0925],
                [500000, 1000000, 0.0975],
                [1000000, 999999999, 0.1075],
            ],
            // standardDeduction: 20800,
        },
        MARRIED_JOINTLY: {
            brackets: [
                [0, 10000, 0.04],
                [10000, 40000, 0.06],
                [40000, 60000, 0.065],
                [60000, 250000, 0.085],
                [250000, 500000, 0.0925],
                [500000, 1000000, 0.0975],
                [1000000, 999999999, 0.1075],
            ],
            // standardDeduction: 27700,
        },
        MARRIED_SEPARATELY: {
            brackets: [
                [0, 10000, 0.04],
                [10000, 40000, 0.06],
                [40000, 60000, 0.065],
                [60000, 250000, 0.085],
                [250000, 500000, 0.0925],
                [500000, 1000000, 0.0975],
                [1000000, 999999999, 0.1075],
            ],
            // standardDeduction: 13850,
        },
    },
};
// {
//     type: "flat",
//     SINGLE: { brackets: [] ,personalExemption: 0,
//         standardDeduction: 13850, },
//     "MARRIED_JOINTLY": { brackets: [], personalExemption: 0,
//         standardDeduction: 13850, },
//     "MARRIED_SEPARATELY": { brackets: [] ,personalExemption: 0,
//         standardDeduction: 13850, },
//     "HEAD_OF_HOUSEHOLD": { brackets: [],  personalExemption: 0,
//         standardDeduction: 13850,},
//   },
